export enum REGIONS {
  CAN = 'Canadian Review',
  US = 'US/International Review',
  US_CAN = 'US/International AND Canadian Review',
}
